<div class="auth-error-display">
  <div class="aed-icon-wrap">
    <fa-icon class="aed-icon" [icon]="config.icon" size="5x"></fa-icon>
  </div>
  <div class="aed-code" [attr.data-text]="config.code">{{ config.code }}</div>
  <h1 class="h4 mb-0">{{ config.title }}</h1>
  <p class="text-muted mb-0">{{ config.message }}</p>
  <a routerLink="/" class="btn btn-primary">{{ actionLabel }}</a>
</div>
